import React, { useState } from 'react';
import { Table, Tag, Avatar, Empty, Select, Card } from 'antd';
import { 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  EnvironmentOutlined,
  UserOutlined
} from '@ant-design/icons';

const { Option } = Select;

const AttendanceByLocationView = () => {
  const [year, setYear] = useState('1404');
  const [month, setMonth] = useState('آذر');
  const [location, setLocation] = useState('all');

  // داده‌های نمونه
  const [attendanceData] = useState([
    {
      id: 1,
      employee: 'زهرا احمدی',
      location: 'liveamooz.com',
      date: '1404/09/14',
      entry: '09:00',
      exit: '18:00',
      workFrom: 'دفتر',
      status: 'present',
    },
    {
      id: 2,
      employee: 'صالحه نوربخش',
      location: 'liveamooz.com',
      date: '1404/09/14',
      entry: '09:00',
      exit: '18:00',
      workFrom: 'دفتر',
      status: 'present',
    },
  ]);

  const getStatusColor = (status) => {
    const colorMap = {
      present: 'green',
      absent: 'red',
      late: 'orange',
    };
    return colorMap[status] || 'default';
  };

  const getStatusText = (status) => {
    const statusMap = {
      present: 'حاضر',
      absent: 'غیبت',
      late: 'تاخیر',
    };
    return statusMap[status] || status;
  };

  const columns = [
    {
      title: 'کارمند',
      dataIndex: 'employee',
      key: 'employee',
      render: (text) => (
        <div className="flex items-center gap-2">
          <Avatar icon={<UserOutlined />} size="small" />
          <span style={{ fontFamily: 'CustomFont' }}>{text}</span>
        </div>
      ),
    },
    {
      title: 'موقعیت مکانی',
      dataIndex: 'location',
      key: 'location',
      render: (text) => (
        <div className="flex items-center gap-2">
          <EnvironmentOutlined />
          <span style={{ fontFamily: 'CustomFont' }}>{text}</span>
        </div>
      ),
    },
    {
      title: 'تاریخ',
      dataIndex: 'date',
      key: 'date',
      render: (text) => <span style={{ fontFamily: 'CustomFont' }}>{text}</span>,
    },
    {
      title: 'ورود',
      dataIndex: 'entry',
      key: 'entry',
      render: (text) => text || '-',
    },
    {
      title: 'خروج',
      dataIndex: 'exit',
      key: 'exit',
      render: (text) => text || '-',
    },
    {
      title: 'کار از',
      dataIndex: 'workFrom',
      key: 'workFrom',
      render: (text) => <span style={{ fontFamily: 'CustomFont' }}>{text}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={getStatusColor(status)}>
          {getStatusText(status)}
        </Tag>
      ),
    },
  ];

  return (
    <div style={{ fontFamily: 'CustomFont' }}>
      {/* فیلترها */}
      <div className="mb-4 flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <span className="text-gray-600 dark:text-gray-400">سال:</span>
          <Select
            value={year}
            onChange={setYear}
            style={{ width: 120, fontFamily: 'CustomFont' }}
          >
            <Option value="1404">۱۴۰۴</Option>
            <Option value="1403">۱۴۰۳</Option>
            <Option value="1402">۱۴۰۲</Option>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-gray-600 dark:text-gray-400">ماه:</span>
          <Select
            value={month}
            onChange={setMonth}
            style={{ width: 120, fontFamily: 'CustomFont' }}
          >
            <Option value="آذر">آذر</Option>
            <Option value="آبان">آبان</Option>
            <Option value="مهر">مهر</Option>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-gray-600 dark:text-gray-400">موقعیت:</span>
          <Select
            value={location}
            onChange={setLocation}
            style={{ width: 200, fontFamily: 'CustomFont' }}
          >
            <Option value="all">همه</Option>
            <Option value="liveamooz.com">liveamooz.com</Option>
          </Select>
        </div>
      </div>

      {/* جدول */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <Table
          columns={columns}
          dataSource={attendanceData}
          rowKey="id"
          pagination={false}
          locale={{
            emptyText: (
              <Empty
                description={<span style={{ fontFamily: 'CustomFont' }}>هیچ رکوردی یافت نشد</span>}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ),
          }}
          style={{ fontFamily: 'CustomFont' }}
        />
      </div>
    </div>
  );
};

export default AttendanceByLocationView;
